<!-- Título del Modal -->
<h2 mat-dialog-title>{{ 'TEMPLATE_WHATSAPP_FLOW.LIST.TITLE' | translate }}</h2>

<!-- Contenido del Modal -->
<mat-dialog-content>
  <!-- Barra de Búsqueda -->
  <!--mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Buscar</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput (keyup)="filtrarFlujos($event)" placeholder="Escribe el nombre del flujo">
    </mat-form-field-->

  <mat-radio-group [(ngModel)]="flujoSeleccionado" class="w-100">
    <!-- 3. El contenedor para la lista: mat-list -->
    <mat-list role="list">
      <mat-list-item
        *ngFor="let flujo of flujosFiltrados"
        role="listitem"
        class="list-item mb-3">
        <mat-radio-button [value]="flujo" color="primary">
          <div class="flow-info py-2">
            <span class="font-weight-bold">{{ flujo.name }}</span>
            <span class="text-muted small"
              >Actualizado el {{ flujo.createdAt | date: 'dd MMM. yyyy' }}</span
            >
          </div>
        </mat-radio-button>
      </mat-list-item>
    </mat-list>
  </mat-radio-group>

  <!-- Mensaje si no hay resultados -->
  <div *ngIf="flujosFiltrados.length === 0" class="text-center p-4">
    No se encontraron flujos.
  </div>
</mat-dialog-content>

<!-- Acciones del Modal (Botones) -->
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancelarClick()">Cancelar</button>
  <!-- 4. Corregimos la lógica del [disabled] -->
  <button
    mat-flat-button
    color="primary"
    [disabled]="!flujoSeleccionado"
    (click)="onConfirmarClick()">
    Seleccionar
  </button>
</mat-dialog-actions>
